import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Popover,
  Select,
  Space,
  Spin,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import GoogleAutoComplete from 'react-google-autocomplete';
import { ReactSession } from 'react-client-session';
import moment from 'moment';
import PropTypes from 'prop-types';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Col, Row } from 'react-bootstrap';
import './index.css';

import {
  rentalsPeriods,
  addtoCart,
  getDeliverWindows,
  getExtraWork,
  getExtraWorkInventory,
  addDelivery,
  checkZipCode,
  getUnavaliableDays,
  getBlockedDays
} from '../../../data/API';
import {
  setDeliveryInfo,
  setStepCount,
  setCustomerAddress,
  setPickupDetails
} from '../store/actionCreators';
import { handleEventClick } from '../index';
import fetchBubbleContent from '../../../utils';
import { get } from 'lodash';
import { processTimeSlotsResponse, getSubmissionValue } from '../../../utils/timeSlotUtils';

const DeliveryDetails = (props) => {
  const dispatch = useDispatch();

  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;
  const session = ReactSession.get('session');

  const currentStep = useSelector((state) => state.package.currentStep);
  const { selectedRentalPeriod } = useSelector((state) => state.package.choosePackage);
  const deliveryInfo = useSelector((state) => state.package.deliveryDetails.deliveryInfo);
  const pickupInfo = useSelector((state) => state.package.pickupDetails.pickupInfo);

  const [form] = Form.useForm();
  const [timingOne, setTimingOne] = useState(null);
  const [timingTwo, setTimingTwo] = useState(null);
  const [rentalPeriods, setRentalPeriods] = useState([]);
  const [deliveryWindows1, setDeliveryWindows1] = useState([]);
  const [deliveryWindows2, setDeliveryWindows2] = useState([]);
  const [extraWork, setExtraWork] = useState([]);
  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [zipCodeError, setZipCodeError] = useState(null);
  const [deliveryAddressError, setDeliveryAddressError] = useState(null);
  const [unavaliableDates, setUnavaliableDates] = useState(null);
  // const [intialFormValues, setIntialFormValues] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [disableDays, setDisableDays] = useState([]);
  const { isParentNextStepClicked, setParentNextStepClicked } = props;
  const [bubbleContents, setBubbleContents] = useState({});
  const { selectedPackage } = useSelector((state) => state.package.choosePackage);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const obj = { title: "Stairs and Elevators" }; 

  const intialFormValues = {
    delivery_date: deliveryInfo?.delivery_date ? dayjs(deliveryInfo?.delivery_date) : '',
    delivery_window_1: deliveryInfo?.window_1 ? deliveryInfo?.window_1 : '', 
    delivery_window_2: deliveryInfo?.window_2 ? deliveryInfo?.window_2 : '',
    apt_number: deliveryInfo?.apt_number ? deliveryInfo?.apt_number : '',
    extra_work: deliveryInfo?.extra_work ? deliveryInfo?.extra_work : '',
    description: deliveryInfo?.description ? deliveryInfo?.description : ''
  };

  const onFinish = (val) => {
    message.success('Submit success!');
  };

  const onFinishFailed = () => {
    message.error('Submit failed!');
  };

  const prevStep = () => {
    dispatch(setStepCount(currentStep - 1));
  };

  const handleTimingOneChange = (evt) => {
    setTimingOne(evt);

    if (evt == timingTwo) {
      setTimingTwo(null);
    }
  };

  const handleTimingTwoChange = (evt) => {
    setTimingTwo(evt);
  };

  const getRentalPeriods = async () => {
    try {
      let rentalPeriodsRes = await rentalsPeriods();

      if (rentalPeriodsRes?.data) {
        setRentalPeriods(rentalPeriodsRes?.data.results);
      }
    } catch (err) {
      return message.error('error fetching rental periods', err);
    }
  };

  const getDeliverySlots = async (selectedDate = null) => {
    try {
      let dayName = null;
      if (selectedDate) {
        let dateToUse;
        if (selectedDate.$d) {
          dateToUse = selectedDate.$d;
        } else if (selectedDate._d) {
          dateToUse = selectedDate._d;
        } else {
          dateToUse = selectedDate;
        }

        const momentDate = moment(dateToUse);
        dayName = momentDate.format('dddd'); 
        console.log('Extracted day name:', dayName, 'from date:', dateToUse);
      }

      console.log('Calling API with dayName:', dayName);
      let response = await getDeliverWindows(dayName);
      console.log('API response:', response);

      if (response?.data) {
        console.log('Response data results:', response.data.results);

        if (response.data.results.length > 0 && response.data.results[0].day_of_week) {
          console.log('Processing day-specific slots - API already processed them');
          const processedSlots = response.data.results.map((slot, index) => ({
            id: slot.id,
            database_id: slot.id,
            start_time: slot.start_time,
            end_time: slot.end_time,
            display_value: `${slot.start_time} - ${slot.end_time}`,
            submission_value: slot.id,
            is_day_specific: true,
            slot_type: slot.slot_type,
            day_of_week: slot.day_of_week
          }));

          const anytimeSlots = processedSlots.filter(slot =>
            slot.start_time?.toLowerCase().includes('anytime') ||
            slot.end_time?.toLowerCase().includes('anytime') ||
            slot.slot_type?.toLowerCase() === 'anytime'
          );
          const regularSlots = processedSlots.filter(slot =>
            !slot.start_time?.toLowerCase().includes('anytime') &&
            !slot.end_time?.toLowerCase().includes('anytime') &&
            slot.slot_type?.toLowerCase() !== 'anytime'
          );

          const finalProcessedSlots = [...regularSlots, ...anytimeSlots];

          console.log('Final processed slots:', finalProcessedSlots);
          setDeliveryWindows1(finalProcessedSlots);
          setDeliveryWindows2(finalProcessedSlots);
        } else {
          console.log('Using generic slots');
          const genericSlots = response.data.results.map((slot, index) => ({
            id: slot.id,
            database_id: slot.id,
            start_time: slot.start_time,
            end_time: slot.end_time,
            display_value: `${slot.start_time} - ${slot.end_time}`,
            submission_value: slot.id,
            is_day_specific: false,
            slot_type: slot.slot_type,
            day_of_week: slot.day_of_week
          }));

          const anytimeSlots = genericSlots.filter(slot =>
            slot.start_time?.toLowerCase().includes('anytime') ||
            slot.end_time?.toLowerCase().includes('anytime') ||
            slot.slot_type?.toLowerCase() === 'anytime'
          );
          const regularSlots = genericSlots.filter(slot =>
            !slot.start_time?.toLowerCase().includes('anytime') &&
            !slot.end_time?.toLowerCase().includes('anytime') &&
            slot.slot_type?.toLowerCase() !== 'anytime'
          );

          const sortedRegularSlots = regularSlots.sort((a, b) => {
            const timeA = moment(a.start_time, 'h:mm A');
            const timeB = moment(b.start_time, 'h:mm A');
            return timeA.diff(timeB);
          });

          const sortedGenericSlots = [...sortedRegularSlots, ...anytimeSlots];

          console.log('Formatted and sorted generic slots:', sortedGenericSlots);
          setDeliveryWindows1(sortedGenericSlots);
          setDeliveryWindows2(sortedGenericSlots);
        }
      } else {
        console.log('No response data received');
        setDeliveryWindows1([]);
        setDeliveryWindows2([]);
      }
    } catch (err) {
      console.error('Error fetching delivery windows:', err);
      return message.error('error fetching delivery windows', err);
    }
  };

  useEffect(() => {
    if (selectedProductId) {
      getExtarworkInfo(selectedProductId);
    }
  }, [selectedProductId]);

  const getExtarworkInfo = async (productId = null) => {
    console.log("Calling getExtraWork with productId:", productId);
    try {
      let response = await getExtraWorkInventory(productId, 'delivery');
      console.log("Response from getExtraWork:", response);
      if (response?.data) {
        setExtraWork(response?.data.results);
      }
    } catch (err) {
      console.error("Error fetching extra work:", err);
      return message.error('error fetching extra work info windows', err);
    }
  };

  const onStairsSelected = async (value) => {
    let formValues = await form.validateFields();
    try {
      const window1SubmissionValue = getSubmissionValue(formValues?.delivery_window_1, deliveryWindows1);
      const window2SubmissionValue = getSubmissionValue(formValues?.delivery_window_2, deliveryWindows2);

      let data = {
        extra_work: value,
        session: session,
        delivery_date: moment(formValues.delivery_date?.$d).format('YYYY-MM-DD'),
        rental: selectedRentalPeriod.id,
        delivery_address: deliveryAddress,
        selected_window_1: window1SubmissionValue,
        selected_window_2: window2SubmissionValue
      };

      if (formValues?.apt_number) {
        data['apt_number'] = formValues.apt_number;
      }

      if (formValues?.description) {
        data['description'] = formValues.description;
      }

      let deliveryRes = await addDelivery(data);
      deliveryRes.data.extra_work=deliveryRes.data.extrawork

      if (deliveryRes?.data?.id) {
        const window1Slot = deliveryWindows1.find(slot =>
          slot.display_value === formValues['delivery_window_1'] || slot.id === formValues['delivery_window_1']
        );
        const window2Slot = deliveryWindows2.find(slot =>
          slot.display_value === formValues['delivery_window_2'] || slot.id === formValues['delivery_window_2']
        );

        // Store the display values for form initialization
        deliveryRes['data']['window_1'] = formValues['delivery_window_1'];
        deliveryRes['data']['window_2'] = formValues['delivery_window_2'];
        // Store the database IDs for proper handling
        deliveryRes['data']['window_1_id'] = window1SubmissionValue;
        deliveryRes['data']['window_2_id'] = window2SubmissionValue;
        deliveryRes['data']['delivery_window_1'] = window1Slot;
        deliveryRes['data']['delivery_window_2'] = window2Slot;

        dispatch(setDeliveryInfo(deliveryRes?.data));
      }
    } catch (err) {
      return message.error('Error while adding delivery info', err);
    }
  };

  const fetchUnavaliableDates = async () => {
    try {
      let allDates = [];
       let currentPage = 1;
       let hasNextPage = true;
       
       while (hasNextPage) {
         const response = await getUnavaliableDays(currentPage);
         
         if (response.data.results) {
           allDates = [...allDates, ...response.data.results];
         }
         
         if (response.data.next) {
           currentPage++;
         } else {
           hasNextPage = false;
         }
       }
       
       setUnavaliableDates(allDates);
     } catch (err) {
       return message.error('Error Fetching Blocked Dates', err);
     }
  };

  useEffect(() => {
    if (deliveryInfo?.delivery_address) setDeliveryAddress(deliveryInfo?.delivery_address);

    if (deliveryInfo?.delivery_date) {
      console.log('Setting selectedDeliveryDate from deliveryInfo:', deliveryInfo.delivery_date);
      const dateObj = dayjs(deliveryInfo.delivery_date);
      setSelectedDeliveryDate(dateObj);
    }
  }, [deliveryInfo]);

  useEffect(() => {
    window.scrollTo({
      top: props.tabref.current.offsetTop - 100,
      behavior: 'smooth'
    });
  }, []);

  // Init Invocations
  useEffect(() => {
    getRentalPeriods();
    getDeliverySlots();
    fetchUnavaliableDates();

    if (selectedPackage && selectedPackage.id) {
      setSelectedProductId(selectedPackage.id);
    }
  }, []);

  const setAddress = async (place) => {
    setDeliveryAddress(place?.formatted_address);

    let postal, country, city, state;
    place.address_components.forEach((address_element) => {
      if (address_element.types.includes('postal_code')) postal = address_element.long_name;
      if (address_element.types.includes('country')) country = address_element.short_name;
      if (address_element.types.includes('locality')) city = address_element.long_name;
      if (address_element.types.includes('administrative_area_level_1'))
        state = address_element.long_name;
    });

    const address = {
      city: city,
      country: country,
      line1: place?.formatted_address,
      state: state,
      postal: postal
    };

    dispatch(setCustomerAddress(address));

    let zipCodeRes = await checkZipCode({ deliveryzipcode: postal ? postal : '781006' });

    if (zipCodeRes?.data?.success === true) {
      setZipCodeError(null);
    } else {
      setZipCodeError(zipCodeRes?.data?.message_2);
    }
  };

  const onSubmit = async () => {
    try {
      setIsFormSubmitted(true);

      if (!deliveryAddress) {
        setDeliveryAddressError('Please select delivery address');
      }

      let formValues = await form.validateFields();

      if (formValues.errorFields?.length) {
        setIsFormSubmitted(false);
        return;
      }

      if (zipCodeError) {
        setIsFormSubmitted(false);
        return;
      }

      if (!deliveryAddress) {
        setIsFormSubmitted(false);
        setDeliveryAddressError('Please select delivery address');
        return;
      }

      if (deliveryInfo && deliveryInfo?.delivery_date) {
        if (pickupInfo) {
          pickupInfo['pickup_date'] = null;
          dispatch(setPickupDetails(pickupInfo));
        }
      }

      const window1SubmissionValue = getSubmissionValue(formValues?.delivery_window_1, deliveryWindows1);
      const window2SubmissionValue = getSubmissionValue(formValues?.delivery_window_2, deliveryWindows2);

      const getSelectedDisplayValue = (selectedValue, windowSlots) => {
        console.log('getSelectedDisplayValue - Input:', selectedValue, 'Slots:', windowSlots);
        if (!selectedValue || !windowSlots) return null;
        const selectedSlot = windowSlots.find(slot =>
          slot.display_value === selectedValue || slot.id === selectedValue || slot.id === parseInt(selectedValue)
        );
        console.log('getSelectedDisplayValue - Found slot:', selectedSlot);
        const result = selectedSlot?.display_value || selectedValue;
        console.log('getSelectedDisplayValue - Returning:', result);
        return result;
      };

      let data = {
        session: session,
        delivery_date: moment(formValues.delivery_date?.$d).format('YYYY-MM-DD'),
        rental: selectedRentalPeriod.id,
        delivery_address: deliveryAddress,
        selected_window_1: window1SubmissionValue,
        selected_window_2: window2SubmissionValue,
        extra_work: formValues?.extra_work
      };

      if (formValues?.apt_number) {
        data['apt_number'] = formValues.apt_number;
      }

      if (formValues?.description) {
        data['description'] = formValues.description;
      }

      let deliveryRes = await addDelivery(data);

      if (deliveryRes?.data?.id) {
        const window1Slot = deliveryWindows1.find(slot =>
          slot.display_value === formValues['delivery_window_1'] || slot.id === formValues['delivery_window_1']
        );
        const window2Slot = deliveryWindows2.find(slot =>
          slot.display_value === formValues['delivery_window_2'] || slot.id === formValues['delivery_window_2']
        );

        deliveryRes['data']['window_1'] = formValues['delivery_window_1'];
        deliveryRes['data']['window_2'] = formValues['delivery_window_2'];
        deliveryRes['data']['window_1_id'] = window1SubmissionValue;
        deliveryRes['data']['window_2_id'] = window2SubmissionValue;
        deliveryRes['data']['delivery_window_1'] = window1Slot;
        deliveryRes['data']['delivery_window_2'] = window2Slot;

        dispatch(setDeliveryInfo(deliveryRes?.data));
        dispatch(setStepCount(currentStep + 1));
      }
    } catch (err) {
      setIsFormSubmitted(false);
      return message.error(err);
    }
  };

  const onAddresschange = (e) => {
    if (deliveryAddress && e.target.value == 0) {
      setDeliveryAddress('');
      setDeliveryAddressError('Please Select Delivery Address');
    }
  };
  const blockedDays = () => {
    getBlockedDays().then((res) => {
      const blockedDaysArray = res?.data?.results?.map((obj) => obj.day) || [];
      setDisableDays(blockedDaysArray);
    });
  };
  useEffect(() => {
    blockedDays();
  }, []);

  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(null);

  useEffect(() => {
    if (selectedDeliveryDate) {
      console.log('useEffect - Fetching slots for date:', selectedDeliveryDate);
      getDeliverySlots(selectedDeliveryDate);
    } else {
      console.log('useEffect - No selectedDeliveryDate, clearing slots');
      setDeliveryWindows1([]);
      setDeliveryWindows2([]);
    }
  }, [selectedDeliveryDate]);

  useEffect(() => {
    if (isParentNextStepClicked) {
      setParentNextStepClicked(false);
      onSubmit();
    }
  }, [isParentNextStepClicked]);

  const disableDate = (current) => {
    const todayDate = moment();
    const threePM = moment().set({ hour: 15, minute: 0, second: 0 }); // Set the time to 3:00 PM PST

    return (
      todayDate >= current.$d ||
      (current.$d === moment(todayDate).add(1, 'days') && todayDate.isAfter(threePM)) ||
      (moment(todayDate).add(1, 'days').format('MM-DD-YYYY') ===
        moment(current.$d).format('MM-DD-YYYY') &&
        todayDate.isAfter(threePM)) ||
      disableDays.includes(moment(current.$d).format('dddd')) ||
      unavaliableDates.some(
        (date) => moment(date.date).format('MM-DD-YYYY') === moment(current.$d).format('MM-DD-YYYY')
      )
    );
  };

  return (
    <div>
      <div className="steps bg-white" id="steps">
        <h2 className="shopping-cart-header text-white text-center py-2 fs-20 steps-title">
          Step 4: Delivery Details
        </h2>
        <Card bordered={false} className="w-100 pl-3 pr-3 pt-3">
          <Spin spinning={isFormSubmitted} tip="processing...">
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={intialFormValues}
              style={{ position: 'relative', zIndex: 0 }}>
              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="delivery_date"
                    label="Delivery Date"
                    rules={[{ required: true, message: 'Please choose a delivery date' }]}>
                    <DatePicker
                      className="w-100"
                      size="large"
                      format="MM-DD-YYYY"
                      disabledDate={disableDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(date) => {
                        console.log('Date changed:', date);
                        setSelectedDeliveryDate(date);
                        // Immediately fetch slots for the new date
                        if (date) {
                          console.log('Immediately fetching slots for:', date);
                          getDeliverySlots(date);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                {/* <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Form.Item name="rental" label="Rental Period" rules={[{ required: true, message: "Please select a rental period" }]}>
                      <Select size="large" defaultValue={selectedRentalPeriod.period}>

                        {
                          rentalPeriods.map((obj) => {
                            return (<Select.Option value={obj.id} key={obj.id}>{obj.period}</Select.Option>)
                          })
                        }

                      </Select>
                    </Form.Item>
                  </Col> */}
              </Row>

              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="delivery_window_1"
                    label="Delivery Window 1"
                    rules={[{ required: true, message: 'Please choose a delivery window 1' }]}>
                    <Select
                      onClick={handleEventClick}
                      size="large"
                      placeholder="Select a time slot"
                      value={timingOne}
                      onChange={handleTimingOneChange}>
                      {deliveryWindows1?.map((options, index) => {
                        const displayText = options?.display_value || 
                                          (options?.start_time && options?.end_time ? 
                                            `${options.start_time} - ${options.end_time}` : 
                                            options?.id);
                        const optionValue = options?.display_value || options?.id;
                        
                        return (
                          <Select.Option
                            key={`timing_one_${index}`}
                            hidden={optionValue == timingTwo}
                            value={optionValue}>
                            {displayText}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="delivery_window_2"
                    label="Delivery Window 2"
                    rules={[{ required: true, message: 'Please choose a delivery window 2' }]}>
                    <Select
                      onClick={handleEventClick}
                      size="large"
                      placeholder="Select a time slot"
                      onChange={handleTimingTwoChange}
                      value={timingTwo}
                      disabled={!timingOne}>
                      {deliveryWindows2?.map((options, index) => {
                        const displayText = options?.display_value || 
                                          (options?.start_time && options?.end_time ? 
                                            `${options.start_time} - ${options.end_time}` : 
                                            options?.id);
                        
                        const optionValue = options?.display_value || options?.id;
                        
                        return (
                          <Select.Option
                            hidden={optionValue == timingOne}
                            key={`timing_two_${index}`}
                            value={optionValue}>
                            {displayText}
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    className="mandatory-field"
                    name="delivery_address"
                    label="Delivery Address">
                    <GoogleAutoComplete
                      className={
                        deliveryAddressError && !deliveryAddress
                          ? 'form-control delivery-address-field-error '
                          : 'form-control'
                      }
                      apiKey={apiKey}
                      onPlaceSelected={(place) => {
                        setAddress(place);
                      }}
                      onChange={(e) => {
                        onAddresschange(e);
                      }}
                      options={{
                        types: ['address'],
                        componentRestrictions: { country: 'us' }
                      }}
                      defaultValue={deliveryInfo?.delivery_address}
                    />
                    <p className="mb-0 ant-form-item-explain-error">
                      {zipCodeError ? zipCodeError : null}
                    </p>
                    <p className="mb-0 ant-form-item-explain-error">
                      {deliveryAddressError && !deliveryAddress ? deliveryAddressError : ''}
                    </p>
                    <p className="mb-0 text-success">
                      {!zipCodeError && deliveryAddress ? 'Services available in this area' : null}
                    </p>
                  </Form.Item>
                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item name="apt_number" label="Apt. #" rules={[{ required: false }]}>
                    {/* <Input size="large" placeholder="Apt" /> */}
                    <InputNumber
                      className="w-100"
                      placeholder="Apt."
                      size="large"
                      controls={false}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    className='tool-tip'
                    name="extra_work"
                    size="large"
                    label={
                      <div style={{ display: "flex", width: "100%", alignItems: "center", gap: "10px" }}>
                        <span>Do you have stairs or an elevator? </span>
                        <Popover 
                           content={
                             <div className="box-popover">
                               <p>{bubbleContents[obj.title] || 'Loading...'}</p>
                             </div>
                           }
                           trigger="hover"
                           onVisibleChange={(visible) => {
                             if (visible) {
                               console.log("Fetching content for:", obj.title);
                               fetchBubbleContent(obj.title, setBubbleContents);
                             }
                           }}
                         >
                           <i className="fa fa-info-circle color-primary" aria-hidden="true"></i>
                         </Popover>
                      </div>}
                    rules={[{ required: true, message: 'Please select an option from below' }]}>
                    <Select size="large" onClick={handleEventClick} onChange={onStairsSelected}>
                      {extraWork?.map((obj, index) => {
                        return (
                          <Select.Option
                            className="mobile-wide-option"
                            key={`extarwork_${index}`}
                            value={obj?.id}>{`${obj.title} ($${obj.price})`}</Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                </Col>
                <Col className="px-3 py-0" xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                  <Form.Item
                    name="description"
                    label="Is there anything else we should know?"
                    rules={[{ required: false }]}>
                    <TextArea
                      autoSize={{
                        minRows: 3,
                        maxRows: 5
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </div>

      <div className="row mt-4 mb-10 p-2">
        <div className="col  d-flex justify-content-start align-items-center">
          <Button
            className="btn-previous-step red-border-button"
            icon={<ArrowLeftOutlined />}
            onClick={prevStep}
            size={'large'}>
            Previous Step
          </Button>
        </div>
        <div className="col  d-flex justify-content-end align-items-center">
          <Button
            className="btn-next-step red-button"
            icon={<ArrowRightOutlined />}
            onClick={onSubmit}
            loading={isFormSubmitted}
            size={'large'}>
            {!isFormSubmitted ? 'Next Step' : 'Submitting..'}
          </Button>
        </div>
      </div>
    </div>
  );
};

DeliveryDetails.propTypes = {
  isParentNextStepClicked: PropTypes.any,
  tabref: PropTypes.any,
  setParentNextStepClicked: PropTypes.func
};

export default DeliveryDetails;
